import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./MobileLayout.module.css";
import { useLogin } from "../../authConfig";
import { useClinicalFilters } from "../../clinicalContext";
import { LoginButton } from "../../components/LoginButton";
import { PatientPicker } from "../../components/PatientPicker";
import { PatientRequiredModal } from "../../components/PatientRequiredModal";

const MobileLayout = () => {
    const { t } = useTranslation();
    const { filters } = useClinicalFilters();

    return (
        <div className={styles.layout}>
            <header className={styles.header}>
                <div className={styles.headerContainer}>
                    <Link to="/mobile/chat" className={styles.headerTitle}>
                        <h3>AI Search{filters.patientName ? <span className={styles.patientName}> • {filters.patientName}</span> : null}</h3>
                    </Link>
                    <div className={styles.headerRight}>{useLogin && <LoginButton compact />}</div>
                </div>
                <div className={styles.patientBar}>
                    <PatientPicker />
                </div>
            </header>
            <PatientRequiredModal />
            <main className={styles.main}>
                <Outlet />
            </main>
        </div>
    );
};

export default MobileLayout;
